import apiClient from "../api/apiClient";
import { ENDPOINTS } from "../api/endPoints";
import { createFeedFormData } from "../models/feedModel";

export const createFeed = async (values) => {
  const payload = createFeedFormData(values);
  try {
    // Let the browser supply the multipart boundary, as in dogService.
    const response = await apiClient.post(ENDPOINTS.CREATE_FEED, payload, { timeout: 30000 });
    if (response.data?.status === false || response.data?.success === false) {
      throw new Error(response.data.message || "Unable to publish your post.");
    }
    if (response.data?.status !== true || response.data?.data?.id == null) {
      throw new Error("The server did not return a saved post. Check before submitting again to avoid a duplicate.");
    }
    return response.data;
  } catch (error) {
    if (error.code === "ECONNABORTED" || !error.response && !error.message) {
      throw new Error("The server did not confirm your post. Check before submitting again to avoid a duplicate.");
    }
    throw new Error(error.response?.data?.message || error.message || "Unable to publish your post. Please try again.");
  }
};

export const getAllFeeds = async ({ signal, userId, category } = {}) => {
  const params = {};
  if (userId != null) params.userId = userId;
  if (category && category !== "All" && category !== "Events") params.category = category;
  const response = await apiClient.get(ENDPOINTS.GET_ALL_FEEDS, {
    signal, timeout: 20000,
    ...(Object.keys(params).length ? { params } : {}),
  });
  if (response.data?.status !== true || !Array.isArray(response.data.data)) {
    throw new Error(response.data?.message || "Unable to load the feed.");
  }
  return response.data.data;
};

export const getFeedById = async (id, { signal } = {}) => {
  if (id == null || String(id).trim() === "") throw new Error("A feed ID is required.");
  const response = await apiClient.get(ENDPOINTS.GET_FEED_BY_ID(id), { signal, timeout: 20000 });
  if (response.data?.status !== true || !response.data.data || String(response.data.data.id) !== String(id)) {
    throw new Error(response.data?.message || "Unable to load this post.");
  }
  return response.data.data;
};
